export default "__VITE_ASSET__DGlAPlsR__"